<template>
  <div id="Bannerlist">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">頁腳母層管理</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">頁腳</li>
              <li class="breadcrumb-item active">頁腳母層管理</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-8">
            <div class="b-filter">
              <div>列表排序方式與網站頁腳（Footer）母層從左至右次序關聯</div>
            </div>
          </div>
          <div class="col-sm-2">
            <el-button style="width: 100%" type="primary" @click="add"
              ><i class="nav-icon fas fa-pen fa-sm mr-1"></i>新增</el-button
            >
          </div>
          <div class="col-sm-2">
            <el-button style="width: 100%" @click="saveOrder"
              ><i class="nav-icon fas fa-save fa-sm mr-1"></i
              >保存當前排序</el-button
            >
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <table id="programme-list" class="table table-bordered">
                  <tr>
                    <th></th>
                    <th>母層項目名稱</th>
                    <th>狀態</th>
                    <th>操作</th>
                  </tr>
                  <tbody id="parent-items" class="list-group">
                    <tr
                      class="list-group-item"
                      v-for="item in BannerList"
                      :key="item.id"
                      style="width: 100%"
                    >
                      <td class="cell-xs" style="width: 1%">
                        <i
                          class="fas fa-arrows-alt-v mr-3 handle"
                          v-if="item.id !== -1"
                        ></i>
                      </td>
                      <td class="b-parent-name cell-md">
                        {{ item.sgL_Title }}
                      </td>
                      <td>
                        <div v-if="item.id !== -1">
                          <span
                            v-if="item.sgL_IsShow"
                            class="b-status b-status-display"
                            >顯示</span
                          >
                          <span class="b-status b-status-hidden" v-else
                            >隱藏</span
                          >
                        </div>
                        <div v-else>狀態</div>
                      </td>
                      <td class="b-operate">
                        <div v-if="item.id === -1">操作</div>
                        <div v-else>
                          <span
                            type="button"
                            class="b-operate-btn edit"
                            @click="edit(item.id)"
                          >
                            編輯 </span
                          ><span
                            type="button"
                            class="b-operate-btn danger"
                            @click="del(item.id, item.sgL_Title)"
                          >
                            刪除
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
    <el-dialog
      title="操作数据"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-position="top">
        <el-form-item label="項目名稱">
          <el-input
            v-model="form.sgL_Title"
            placeholder="e.g. 關於我們、業務合作、外部連結…"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="狀態">
          <el-select
            v-model="form.sgL_IsShow"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="顯示" :value="true"></el-option>
            <el-option label="隱藏" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addData">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
import Sortable from "sortablejs";

export default {
  components: {},
  data() {
    return {
      form: {
        id: 0,
        sgL_Title: "",
        sgL_IsShow: true,
      },
      SGL_MenuPersionName: "",
      dialogVisible: false,
      searchText: "",
      selectValue: "",
      BannerList: null,
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 10, //顯示條數
      },
      loading: true,
    };
  },
  created() {
    this.getBannerList();
  },
  watch: {
    selectValue: {
      handler(newvalue, oldvalue) {
        this.handleCurrentChange(1);
      },
    },
  },
  mounted() {
    this.test();
  },
  methods: {
    test() {
      var that = this;
      var el = document.getElementById("parent-items");
      // 常用
      new Sortable(el, {
        onEnd: function (evt) {
          that.BannerList.splice(
            evt.newIndex,
            0,
            that.BannerList.splice(evt.oldIndex, 1)[0]
          );
          var newArray = that.BannerList.slice(0);
          that.BannerList = [];
          that.$nextTick(function () {
            that.BannerList = newArray;
          });
        },
      });
    },
    saveOrder() {
      //console.log(11111, this.BannerList);
      let params = this.BannerList.map((item, index) => {
        return {
          id: item.id,
          sortID: index,
        };
      });
      this.$api.permissionApi
        .updateFootOrder(params)
        .then((res) => {
          Message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.getBannerList();
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
        });
    },
    addData() {
      let params = {
        sgL_Parent: 0,
        id: this.form.id,
        sgL_Title: this.form.sgL_Title,
        sgL_IsShow: this.form.sgL_IsShow,
        SGL_IsInternaURL: "",
        SGL_IsInternal: false,
      };
      const med =
        this.form.id > 0
          ? this.$api.permissionApi.editFootInfo
          : this.$api.permissionApi.createFoot;
      if (this.form.id === 0) {
        params.sgL_Order = this.BannerList.length;
      }
      med(params)
        .then((res) => {
          if (res.data.success) {
            this.dialogVisible = false;
            Message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
            this.getBannerList();
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
        });
    },
    edit(id) {
      this.$api.permissionApi
        .getFootInfo({ id })
        .then((res) => {
          this.form = res.data.result;
          this.dialogVisible = true;
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
        });
    },
    del(id, name) {
      let msg = `確認刪除母層項目「${name}」?`;
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.permissionApi
          .deleteFootInfo({ id })
          .then((res) => {
            Message({
              type: "success",
              message: "刪除成功",
            });
            this.getBannerList();
          })
          .catch((err) => {
            Message({
              type: "error",
              message: err,
            });
          });
      });
    },
    add() {
      this.form.id = 0;
      this.form.sgL_Title = "";
      this.form.sgL_IsShow = true;
      this.dialogVisible = true;
    },
    getBannerList() {
      this.loading = true;
      let params = {
        SGL_Parent: 0,
      };
      this.$api.permissionApi
        .GetFootList(params)
        .then((res) => {
          if (res.data.success) {
            this.BannerList = res.data.result.items;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
          this.loading = false;
        })
        .then((obj) => {
          this.loading = false;
        });
    },
    selectByType(status) {
      this.selectValue = status;
    },
    searchTextQry() {
      this.handleCurrentChange(1);
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getBannerList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getBannerList();
    },
  },
  computed: {
    GetList() {
      return this.BannerList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminFooter/parent.vue